import { computed, ref } from "@vue/composition-api";
import { Group, GroupParticipant, InputGroupSearch } from "@scrile/api-provider/dist/api/GroupsProvider";
import { FragmentFields } from "@scrile/api-provider/dist/api/types";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export function useGroups({ system }: { system: boolean } = { system: true }) {
  const { authUserStrict } = useAuthUser();
  const groups = ref<Group[]>([]);
  const hasGroupWithMoreThanOneMember = computed(() => groups.value.some(g => g.memberCount > 1));

  const getGroups = async (data: InputGroupSearch) => providers.GroupsProvider.search({ data });

  const getMyGroups = async () => {
    groups.value = await getGroups({ system: system ? undefined : false, ownerId: authUserStrict.value.id });
  };

  const getUserGroupsInfo = async (
    userId: string,
    fields?: FragmentFields<GroupParticipant>
  ): Promise<GroupParticipant[]> => {
    const response = await providers.GroupsProvider.searchMembers(
      {
        data: { userIds: [userId], system: system, size: 2000 },
      },
      fields
    );
    return response.result;
  };

  return {
    groups,
    hasGroupWithMoreThanOneMember,
    getGroups,
    getMyGroups,
    getUserGroupsInfo,
  };
}
